"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerReachOutBusinessVertical = void 0;
var PartnerReachOutBusinessVertical;
(function (PartnerReachOutBusinessVertical) {
    PartnerReachOutBusinessVertical["mortgageLenderBrokerOrServicer"] = "mortgageLenderBrokerOrServicer";
    PartnerReachOutBusinessVertical["homeImprovement"] = "homeImprovement";
    PartnerReachOutBusinessVertical["other"] = "other";
})(PartnerReachOutBusinessVertical || (exports.PartnerReachOutBusinessVertical = PartnerReachOutBusinessVertical = {}));
